import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import type { Event } from "../types/event";

interface EventItemProps {
  event: Event;
  showArrowIcon?: boolean;
}

export const EventItem = ({ event, showArrowIcon = true }: EventItemProps) => {
  const date = new Date(event.starts_at).toLocaleString("en-US", {
    month: "long",
    day: "numeric",
  });

  const time = new Date(event.starts_at).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <a
      className="border-primary bg-primary hover:bg-secondary dark:border-tertiary hover:dark:bg-tertiary mb-2 block cursor-pointer rounded-lg border p-4 shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]"
      href={event.post_url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {event.cover_image_url && (
        <div>
          <img
            loading="lazy"
            alt={event.name}
            className="mb-4 rounded"
            src={event.cover_image_url}
          />
        </div>
      )}
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-2">
          <span className="text-darkest line-clamp-2 text-sm font-semibold">
            {event.name}
          </span>
          <span className="text-tertiary text-[11px] font-medium">
            {date} {t("support_widget.at")} {time}
          </span>
        </div>
        {showArrowIcon && (
          <div className="text-darkest flex shrink-0 items-center self-center">
            <Icon type="sw-right-arrow" size={16} />
          </div>
        )}
      </div>
    </a>
  );
};
